import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Style.
 */

const StyledDropdownIcon = styled.div`
  display: grid;
  grid-area: secondary-content;
  margin: 2px 0 0 4px;

  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const DropdownItemExternalLinkIcon: FC = () => (
  <StyledDropdownIcon>
    <Icon name="externalLinkSmall" />
  </StyledDropdownIcon>
);
